const RefundRequestIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.78329 2.83794C6.40196 0.692349 10.2723 0.841736 12.7167 3.28612C15.3201 5.88962 15.3201 10.1107 12.7167 12.7142C10.1131 15.3177 5.89205 15.3177 3.28856 12.7142C1.60556 11.0312 1.01052 8.67223 1.50342 6.51127L1.55451 6.30279L2.84413 6.64226C2.37913 8.4155 2.84154 10.3816 4.23137 11.7714C6.31416 13.8542 9.69101 13.8542 11.7738 11.7714C13.8566 9.68863 13.8566 6.31172 11.7738 4.22893C9.89541 2.3505 6.96435 2.16618 4.87939 3.676L4.73192 3.78672L5.40988 4.46463L2.34575 5.17174L3.05285 2.10761L3.78329 2.83794ZM8.66928 4.00016V5.3335H10.3359V6.66683H6.66928C6.48517 6.66683 6.33593 6.8161 6.33593 7.00016C6.33593 7.16383 6.45386 7.2999 6.60935 7.3281L6.66928 7.3335H9.33595C10.2564 7.3335 11.0026 8.0797 11.0026 9.00016C11.0026 9.92063 10.2564 10.6668 9.33595 10.6668H8.66928V12.0002H7.33595V10.6668H5.66927V9.3335H9.33595C9.52001 9.3335 9.66928 9.18423 9.66928 9.00016C9.66928 8.8365 9.55135 8.70043 9.39588 8.67223L9.33595 8.66683H6.66928C5.74879 8.66683 5.0026 7.92063 5.0026 7.00016C5.0026 6.07969 5.74879 5.3335 6.66928 5.3335H7.33595V4.00016H8.66928Z"
      fill="#A963FF"
    />
  </svg>
);

export default RefundRequestIcon;
